import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EnumAcaoRecurso } from '../../../models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from '../../../models/enum/recurso-perfil.enum';
import { IPlanoAcaoVersaoModel } from '../../../models/plano-acao-model';
import { AuthService } from '../../../services/auth.service';
import { PlanoAcaoService } from '../../../services/plano-acao.service';
import { PlanoAcaoMonitorImprimirComponent } from '../plano-acao-monitor-imprimir/plano-acao-monitor-imprimir.component';
import { PlanoAcaoMonitorImprimirRelatoriaComponent } from '../plano-acao-monitor-imprimir-relatoria/plano-acao-monitor-imprimir-relatoria.component';
import Swal from 'sweetalert2';

// Demanda 68742 linha 41 – Histórico de versões (protótipo 4.7).
@Component({
  selector: 'app-plano-acao-monitor-versoes',
  templateUrl: './plano-acao-monitor-versoes.component.html',
  styleUrls: ['./plano-acao-monitor-versoes.component.scss']
})
export class PlanoAcaoMonitorVersoesComponent implements OnInit {

  public dataSource = new MatTableDataSource<IPlanoAcaoVersaoModel>([]);
  public displayedColumns: string[] = ['numero', 'descricao', 'dataHora', 'responsavel', 'acoes'];
  public planoAcaoId: number = 0;
  public podeImprimir: boolean = false;
  public podeRelatoria: boolean = false;

  constructor(
    public matDialog: MatDialog,
    private planoAcaoService: PlanoAcaoService,
    private authService: AuthService,
    private dialogRef: MatDialogRef<PlanoAcaoMonitorVersoesComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.planoAcaoId = data?.id;
    this.podeImprimir = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Imprimir);
    this.podeRelatoria = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Relatoria);
  }

  ngOnInit(): void {
    this.obter();
  }

  public obter(): void {
    this.planoAcaoService.obterVersoes(this.planoAcaoId)
      .then((res) => {
        this.dataSource = new MatTableDataSource<IPlanoAcaoVersaoModel>(res.dados || []);
      })
      .catch(() => {
        this.dataSource = new MatTableDataSource<IPlanoAcaoVersaoModel>([]);
      });
  }

  public imprimirPlano(versao: IPlanoAcaoVersaoModel): void {
    this.planoAcaoService.obterVersaoPlano(versao.id)
      .then((res) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-monitor-imprimir-versao';
        dialogConfig.width = '90vw';
        dialogConfig.maxHeight = '90vh';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = { titulo: `Plano de ação – versão ${versao.numero}`, snapshot: JSON.parse(res.dados) };
        this.matDialog.open(PlanoAcaoMonitorImprimirComponent, dialogConfig);
      })
      .catch(() => {
        Swal.fire({ toast: true, position: 'top-end', icon: 'error', text: 'Não foi possível carregar a impressão da versão.', showConfirmButton: false, timer: 5000, timerProgressBar: true });
      });
  }

  public imprimirRelatoria(versao: IPlanoAcaoVersaoModel): void {
    this.planoAcaoService.obterVersaoRelatoria(versao.id)
      .then((res) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-monitor-imprimir-relatoria-versao';
        dialogConfig.width = '90vw';
        dialogConfig.maxHeight = '90vh';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = { titulo: `Relatoria – versão ${versao.numero}`, snapshot: JSON.parse(res.dados) };
        this.matDialog.open(PlanoAcaoMonitorImprimirRelatoriaComponent, dialogConfig);
      })
      .catch(() => {
        Swal.fire({ toast: true, position: 'top-end', icon: 'error', text: 'Não foi possível carregar a relatoria da versão.', showConfirmButton: false, timer: 5000, timerProgressBar: true });
      });
  }

  onFechar(): void {
    this.dialogRef.close();
  }
}
